module.exports = __webpack_public_path__ + "img/2026banner.efb994f9.jpg";